
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.96 5.845c-.05-.055-.102-.083-.154-.083H7.3v.652h.528c.051 0 .1-.029.143-.086a.384.384 0 00.067-.24c0-.106-.026-.187-.077-.243z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M1.073 2.324v8.941h13.854v-8.94H1.074zM5.96 7.7a1.322 1.322 0 01-.318.223 1.759 1.759 0 01-.779.185c-.226 0-.432-.046-.62-.136a1.57 1.57 0 01-.485-.358 1.63 1.63 0 01-.427-1.082 1.503 1.503 0 01.412-1.034 1.547 1.547 0 011.146-.48c.295 0 .55.06.766.182.216.121.377.282.483.483l-.64.454a.539.539 0 00-.27-.3.676.676 0 00-.178-.06.977.977 0 00-.178-.017.645.645 0 00-.311.07.64.64 0 00-.215.185.796.796 0 00-.124.258 1.041 1.041 0 00.006.59.794.794 0 00.138.257.639.639 0 00.515.245.84.84 0 00.175-.02.655.655 0 00.174-.064.587.587 0 00.15-.116.514.514 0 00.106-.174l.682.408a.87.87 0 01-.208.3zm2.19.382l-.536-.936h-.313v.936h-.837V5.034h1.4c.148 0 .285.03.411.092a1.07 1.07 0 01.537.58c.051.126.077.254.077.383 0 .178-.039.343-.116.496a1.01 1.01 0 01-.322.375l.644 1.12H8.15zm3.515 0V6.475l-.51 1.13h-.447l-.51-1.13V8.08H9.36V5.033h.914l.656 1.434.661-1.434h.91v3.048h-.837zM16 12.242H0v1.43h16v-1.43z","fill":"#6C6C6C"}})])
          )
        }
      }
    